import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=1a39d2a7&scoped=true&"
import script from "./SocialMedia.vue?vue&type=script&lang=js&"
export * from "./SocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=1a39d2a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39d2a7",
  null
  
)

export default component.exports